import { createContext, useState } from "react";
import { FormsApi } from "./../common";
import { ApplicationState } from "./services/application-state";

const formsApi = new FormsApi("", "", undefined);
const appState = new ApplicationState(formsApi);

const defaultValue: { formsApi: FormsApi, applicationState: ApplicationState }
  = { formsApi: formsApi, applicationState: appState };
export const DependencyInjectionContext = createContext(defaultValue);

// Create a provider for components to consume and subscribe to changes
export const DependencyInjectionProvider = ({ children, ...services }: { children: any, formsApi: FormsApi, applicationState: ApplicationState }) => {
  const [appData, setAppData] = useState(defaultValue);

  return (
    <DependencyInjectionContext.Provider value={services}>
      {children}
    </DependencyInjectionContext.Provider>
  );
};